import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const switcherClass = ({ isActive }: { isActive: boolean }) => `px-4 py-2 rounded-lg text-sm font-medium transition-all ${
  isActive ? 'bg-slate-800 text-white shadow' : 'text-slate-400 hover:text-white'
}`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  // Recipients opening a secret link only see the secret, not the tools
  const isSecretLink = pathname.startsWith('/secret/');
  const isGenerator = pathname === '/generator';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8 bg-slate-950">
      <header className="mb-12 text-center">
        <div className="flex items-center justify-center gap-2 mb-2">
          <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center shadow-lg shadow-indigo-500/20">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-white">eZeus SecretShare</h1>
        </div>
        <p className="text-slate-400 max-w-md mx-auto">
          {isGenerator
            ? 'Zufällige Passphrasen und Passwörter, direkt in Ihrem Browser erzeugt.'
            : 'Geheime Informationen sicher teilen, mit PIN-geschützten Links.'}
        </p>
        {!isSecretLink && (
          <nav className="inline-flex gap-1 p-1 mt-6 bg-slate-900/50 rounded-xl border border-slate-800">
            <NavLink to="/" end className={switcherClass}>Geheimnis teilen</NavLink>
            <NavLink to="/generator" className={switcherClass}>Passwort-Generator</NavLink>
          </nav>
        )}
      </header>

      <main className="w-full max-w-xl">
        {children}
      </main>

      <footer className="mt-12 text-slate-500 text-sm">
        &copy; {new Date().getFullYear()} Wizard Computersysteme GmbH
      </footer>
    </div>
  );
};

export default Layout;
